import React, { Component } from "react";
import { connect } from "react-redux";
import { createHashHistory } from "history";
import PropTypes from "prop-types";
import {
  FormGroup,
  InputGroup,
  FormControl,
  Button,
  Alert,
  ButtonGroup,
  MenuItem,
  DropdownButton,
  Modal,
  ControlLabel,
} from "react-bootstrap";
import Pagination from "react-js-pagination";
import { NewBreadcrumb as BreadcrumbComponent } from "../../components";

import {
  getInvoicesList,
  deleteInvoices,
  executeInvoices,
  resendInvoices
} from "../../redux/actions/invoicesActions";
import isEmpty from "lodash.isempty";
import moment from "moment";
import "../../style/react-paginating.css";
import Dialog from "react-bootstrap-dialog";
import loader from "../../style/loader/loader.scss";
import ReactHtmlParser from "react-html-parser";

const history = createHashHistory();
let isLoading = "false";
class InvoicesList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invoices: [],
      totalRecords: 0,
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      alertMessage: "",
      msgType: "",
      path: ["Home", "Invoices"],
      links: ["home","invoices"],
      search: "",
      limit: 25,
      show: false,
      isLoading: false,
      modelPaid: "",
      notesForPaid: "",
      invoiceNotesForPaidError: "",
      invoiceNumberIcon: "fa fa-sort-down",
      companyNameIcon: "fa fa-sort-down",
      daysTillOverdueIcon: "fa fa-sort-down",
      statusIcon: "fa fa-sort-down",
      invoice_created_dateIcon: "fa fa-sort-down",
      direction: "",
      orderBy: ""
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.resendInvoices = this.resendInvoices.bind(this);
    this.handleChangePaid = this.handleChangePaid.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleChangePaid(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleExecute() {

      if (this.state.notesForPaid.length === 0) {
      this.setState({
        invoiceNotesForPaidError: "Execution reason is required."
      });
    } else {
      this.setState({ invoiceNotesForPaidError: "" });
    }


    if (this.state.invoicesID !== "") {
      const postData = {
        notesForPaid: this.state.notesForPaid,
        invoicesID: this.state.invoicesID
      };
      this.props.executeInvoices(postData);
      this.handleClose();
      this.handlePageChange(this.state.currentPage);
    }
  }


  handleSearch(e) {
    this.setState({ [e.target.name]: e.target.value });
    let searchstring = e.target.value.length > 0 ? e.target.value : "";
    const postData = {
      page: 1,
      limit: 25,
      search: searchstring
    };
    if (searchstring.length > 0) {
      this.props.getInvoicesList(postData);
    }else{
      this.props.getInvoicesList({ page: this.state.page, limit: this.state.limit });
    }
  }

  handleSort = orderBy => e => {
    e.preventDefault();
    let direction;
    const sortIcon = `${orderBy}Icon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "fa fa-sort-up",
        direction: "ASC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "fa fa-sort-down",
        direction: "DESC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "fa fa-sort-up",
        direction: "ASC",
        orderBy: orderBy
      });
    }
    this.props.getInvoicesList({
      orderBy: orderBy,
      direction: direction,
      limit: this.state.limit
    });
  };

  resendInvoices = (e) => {
    this.setState({isLoading: "true"});
    let invoicesID = e.target.attributes.getNamedItem("data-id").value;
    this.props.resendInvoices({'invoicesID': invoicesID});
  }

  componentWillMount() {
    if (this.props.invoicesResponse && this.props.invoicesResponse.message) {
      this.setState({
        alertMessage: this.props.invoicesResponse.message,
        msgType: "success",
        show: true
      });
    }
    if (this.props.invoicesUpdate && this.props.invoicesUpdate.message) {
      this.setState({
        alertMessage: this.props.invoicesUpdate.message,
        msgType: "success",
        show: true
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.fetchingInvoices !== nextProps.fetchingInvoices) {
      this.setState({ isLoading: nextProps.fetchingInvoices });
    }
    if (
      this.props.invoicesList !== nextProps.invoicesList &&
      !isEmpty(nextProps.invoicesList)
    ) {
      const setPageCount =
      nextProps.invoicesList.total / nextProps.invoicesList.per_page;
      this.setState({ invoices: nextProps.invoicesData });
      this.setState({ totalRecords: nextProps.invoicesList.total });
      this.setState({ perPage: nextProps.invoicesList.per_page });
      this.setState({ pageCount: setPageCount });
    }
    if (
      this.props.deletedInvoices !== nextProps.deletedInvoices &&
      !isEmpty(nextProps.deletedInvoices)
    ) {
      if (nextProps.deletedInvoices.message) {
        this.setState({
          alertMessage: nextProps.deletedInvoices.message,
          msgType: "success",
          show: true
        });
        this.props.getInvoicesList({
          page: this.state.currentPage,
          limit: this.state.limit
        });
      }
    }
    if (this.props.resendStatus !== nextProps.resendStatus) {
      if (nextProps.resendStatus) {
        this.setState({
        alertMessage: nextProps.resendStatus.message,
        msgType: "success",
        show: true,
        isLoading: false
        });
      }
    }
    if (this.props.error !== nextProps.error) {
      this.setState({
        alertMessage: nextProps.error,
        msgType: "warning",
        show: true,
        isLoading: false
      });
    }
  }

  componentDidMount() {
    this.handlePageChange(1);
  }
  componentWillUnmount() {
    this.setState({ alertMessage: "", msgType: "", show: false });
  }

  handlePageChange = page => {
    this.setState({
      currentPage: page
    });

    if (this.state.direction !== "" && this.state.orderBy !== "") {
      this.props.getInvoicesList({
        page: page,
        orderBy: this.state.orderBy,
        direction: this.state.direction,
        limit: this.state.limit
      });
    } else if (this.state.searchString !== "") {
      this.props.getInvoicesList({
        page: page,
        search: this.state.search,
        limit: this.state.limit
      });
    } else {
      this.props.getInvoicesList({ page: page, limit: this.state.limit });
    }
  };

  confirmDelete = invoicesID => {
    this.props.deleteInvoices(invoicesID);
  };

  handleDelete(invoicesID) {
    this.dialog.show({
      body: "Are you sure you want to delete this?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmDelete(invoicesID);
          this.handleShow();
        })
      ]
    });
  }

  handleShowModel(invoicesID) {
    this.setState({
      show: true,
      modelPaid: 'paid',
      invoicesID: invoicesID
    });
  }
  handleClose() {
    this.setState({
      show: false,
      notesForPaid: "",
      invoicesID: ""
    });
  }


  render() {
    const { path } = this.state;
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    const Header = [
      "Invoice Number",
      "Company Name",
      "Days Till Overdue",
      "Status",
      "Invoice From",
      "Invoice Created Date",
      "Invoice Amount",
      "Action"
    ];
    let invoicesRow;
    let invoicesdata = this.state.invoices ? this.state.invoices : [];
    let d1 = new moment().format("DD-MM-YYYY");
    if (invoicesdata) {
      invoicesRow = invoicesdata.map((invoices, index) => (
        <tr key={invoices.invoicesID} style= {{backgroundColor: (invoices.status == 'Overdue') ? 'rgb(251 220 220)' : ''}}>
          <td>0000{invoices.invoiceNumber}</td>
          <td>{invoices.companyName}</td>
          <td>{(invoices.daysTillOverdue) ? moment(invoices.daysTillOverdue).format("MM-DD-YYYY") : ""}</td>          
          <td>{invoices.status}</td>
          <td>{invoices.invoiceFrom}</td>
          <td>{(invoices.invoice_created_date) ? moment(invoices.invoice_created_date).format("MM-DD-YYYY") : ""}</td>
          <td>{invoices.invoiceAmount}</td>      
          <td width="10%">
            <ButtonGroup>
              <DropdownButton title="Action" id="bg-nested-dropdown">
                <MenuItem onClick={() => history.push(`/InvoicesDetails/${invoices.invoicesID}`)}>View</MenuItem>
                {(invoices.invoiceFrom == 'Manual Invoice') ? (<MenuItem onClick={() => history.push(`/AddInvoices/${invoices.invoicesID}`)}>Edit</MenuItem>):("")}
                <MenuItem onClick={this.handleDelete.bind(this, invoices.invoicesID)}>Delete</MenuItem>
                {((invoices.isSent == 'sentMail' && invoices.stripeInvoiceID) || (invoices.oldInvoiceResend == 'true')) &&
                <MenuItem eventKey={Math.random()} data-id={invoices.invoicesID} onClick={this.resendInvoices}> Resend Invoice</MenuItem>
                }
                <MenuItem eventKey={Math.random()} onClick={this.handleShowModel.bind(this, invoices.invoicesID)}>Mark Invoice Paid</MenuItem>
              </DropdownButton>
            </ButtonGroup>
          </td>
        </tr>
      ));
    }

    return (
      <div className="col-lg-12 invoices-list">
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
          </div>
        </div>
        <div className="panel">
          <header className="panel-heading">Manage Unpaid Invoices</header>
          <div className="panel-body">
            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}
            {this.state.isLoading ? (
              <div className="loader">
                <p className="loading-message">
                  <i>Loading...</i>
                </p>
                <div className="spinner">
                  <div className="dot1" />
                  <div className="dot2" />
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="col-lg-12 text-right">
              <Button
                bsStyle="success"
                onClick={() => history.push("/AddInvoices")}
              >
                + Add Invoice
              </Button>
            </div>
            <div className="clearfix" />
            <div className="row m-t-15">
              <div className="col-lg-4 pull-right">
                <FormGroup>
                  <InputGroup>
                    <FormControl
                      type="text"
                      name="search"
                      onChange={this.handleSearch}
                    />
                    <InputGroup.Addon>
                      <i className="fa fa-search" />
                    </InputGroup.Addon>
                  </InputGroup>
                </FormGroup>
              </div>
            </div>
            <div>
              <table className="table table-hover" responsive="true">
                <thead>
                  <tr>
                    <th onClick={this.handleSort("invoiceNumber")}>
                      Invoice Number
                      <span
                        className={this.state.invoiceNumberIcon}
                        aria-hidden="true"
                      />
                    </th>
                    <th onClick={this.handleSort("companyName")}>
                      Company Name
                      <span
                        className={this.state.companyNameIcon}
                        aria-hidden="true"
                      />
                    </th>
                    <th onClick={this.handleSort("daysTillOverdue")}>
                      Days Till Overdue
                      <span
                        className={this.state.daysTillOverdueIcon}
                        aria-hidden="true"
                      />
                    </th>
                    <th onClick={this.handleSort("status")}>
                      Status
                      <span
                        className={this.state.statusIcon}
                        aria-hidden="true"
                      />
                    </th>
                    <th> Invoice From </th>
                    <th onClick={this.handleSort("invoice_created_date")}>
                      Invoice Created Date
                      <span
                        className={this.state.invoice_created_dateIcon}
                        aria-hidden="true"
                      />
                    </th>
                    <th> Invoice Amount </th>
                    <th> Actions </th>
                  </tr>
                </thead>
                <tbody>{invoicesRow}</tbody>
              </table>

              <div className="text-center">
              <Pagination
                  activePage={currentPage}
                  itemsCountPerPage={perPage}
                  totalItemsCount={totalRecords}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              </div>
            </div>
            <div className="clearfix" />
          </div>
        </div>
        {(this.state.modelPaid == "paid") &&
        <Modal show={this.state.show} onHide={this.handleClose.bind(this)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Payment</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <FormGroup controlId="formTermsAndConditions">
                <ControlLabel>Comment</ControlLabel>
                <FormControl
                  value={this.state.notesForPaid}
                  componentClass="textarea"
                  onChange={this.handleChangePaid}
                  name="notesForPaid"
                  placeholder="Comment"
                />
              </FormGroup>
              <p className="inline-validation-error">
                {this.state.invoiceNotesForPaidError !== ""
                  ? this.state.offerTitleError
                  : " "}
              </p>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="success" onClick={this.handleExecute.bind(this)}>
              Update
            </Button>
            <Button bsStyle="danger" onClick={this.handleClose.bind(this)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      }
      </div>
    );
  }
}

InvoicesList.propTypes = {
  getInvoicesList: PropTypes.func.isRequired,
  executeInvoices: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  invoicesList: state.invoicesReducers.invoicesList,
  invoicesData: state.invoicesReducers.invoicesData,
  error: state.invoicesReducers.error,
  deletedInvoices: state.invoicesReducers.deletedInvoices,
  executeInvoices: state.invoicesReducers.executeInvoices,
  invoicesResponse: state.invoicesReducers.invoicesResponse,
  invoicesUpdate: state.invoicesReducers.invoicesUpdate,
  fetchingInvoices: state.invoicesReducers.fetchingInvoices,
  resendStatus: state.invoicesReducers.resendStatus,
});

export default connect(mapStateToProps, { getInvoicesList, deleteInvoices, executeInvoices, resendInvoices })(
  InvoicesList
);



// WEBPACK FOOTER //
// ./src/app/views/invoices/InvoicesList.js